var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (data) {pug_html = pug_html + "\u003Cdiv class=\"ww-improv layout__widget\"\u003E\u003Cdiv class=\"ww-improv__header\" data-js-ww-improv\u003E\u003Cdiv class=\"ww-improv__wrapper\"\u003E\u003Cdiv class=\"ww-improv__container container\"\u003E\u003Cdiv class=\"ww-improv__row\"\u003E\u003Ch1 class=\"ww-improv__text\"\u003EIrvine Improv \u003C\u002Fh1\u003E\u003Ca class=\"ww-improv__address\" target=\"_blank\" href=\"https:\u002F\u002Fwww.google.com\u002Fmaps\u002Fplace\u002FIrvine+Improv+Comedy+Club\u002F@33.6522491,-117.7487058,17z\u002Fdata=!3m2!4b1!5s0x80dce7f9a114ecbb:0xbb81174528352780!4m5!3m4!1s0x80dce7f9a7ef2b27:0xdcc29db1707ff99d!8m2!3d33.6522491!4d-117.7465171\"\u003E527 Spectrum Center Drive, \u003Cbr\u002F\u003EIrvine CA 92618\u003C\u002Fa\u003E\u003Cdiv class=\"ww-improv__contact\"\u003E\u003Cdiv class=\"ww-improv__contact__site\"\u003E \u003Ca href=\"https:\u002F\u002Fimprov.com\u002FIrvine\u002F\" target=\"_blank\"\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"ww-improv__contact__phone\"\u003E \u003Ca href=\"tel:9498545455\"\u003E (949) 854-5455\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"ww-improv__row\"\u003E\u003Cdiv class=\"ww-improv__button-wrapper\" data-js-improv-nav\u003E\u003Cbutton class=\"ww-improv__button ww-improv__button--prev\" data-js-nav-month=\"prev\"\u003E\u003C\u002Fbutton\u003E";
// iterate data
;(function(){
  var $$obj = data;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__month",index==0 ? 'active':''], [false,true]), false, true)+pug.attr("data-js-month-display", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = month.timeDisplay) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__month",index==0 ? 'active':''], [false,true]), false, true)+pug.attr("data-js-month-display", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = month.timeDisplay) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cbutton class=\"ww-improv__button ww-improv__button--next\" data-js-nav-month=\"next\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E";
pug_mixins["improvMovieCard"] = pug_interp = function(type, data, index){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["show-card show-card--" + type], [true]), false, true)+pug.attr("data-show-name", data.title, true, true)) + "\u003E\u003Cdiv class=\"show-card__container\"\u003E\u003Cdiv class=\"show-card__top-section\"\u003E";
if (type === 'movie') {
pug_html = pug_html + "\u003Ca" + (" class=\"show-card__top-section__link\""+pug.attr("href", data.detailPageUrl, true, true)) + "\u003E\u003Cimg" + (pug.attr("src", data.image, true, true)) + "\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", data.image, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"show-card__info-container mobile\"\u003E";
if (type === 'movie') {
pug_html = pug_html + "\u003Ch2 class=\"show-card__title\"\u003E\u003Ca" + (" class=\"show-card__title__link\""+pug.attr("href", data.detailPageUrl, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = data.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fh2\u003E";
}
else {
pug_html = pug_html + "\u003Ch2 class=\"show-card__title\"\u003E" + (pug.escape(null == (pug_interp = data.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
}
if (data.details) {
pug_html = pug_html + "\u003Cdiv class=\"show-card__movie-details\"\u003E" + (null == (pug_interp = data.details) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"show-card__info-container desktop\"\u003E";
if (type === 'movie') {
pug_html = pug_html + "\u003Ch2 class=\"show-card__title\"\u003E\u003Ca" + (" class=\"show-card__title__link\""+pug.attr("href", data.detailPageUrl, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = data.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fh2\u003E";
}
else {
pug_html = pug_html + "\u003Ch2 class=\"show-card__title\"\u003E" + (pug.escape(null == (pug_interp = data.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"showtimes__select-showing\"\u003E ";
if (type === 'movie' || type === 'improv') {
pug_html = pug_html + "\u003Ci class=\"showtimes__ticket-icon icomoon icomoon--ticket\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"showtimes__select-showing__text\"\u003E" + (pug.escape(null == (pug_interp = data.cta) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
pug_mixins["showtimes"] = pug_interp = function(showTimes){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate showTimes
;(function(){
  var $$obj = showTimes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var item = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__info\"\u003E\u003Cdiv class=\"showtimes__title\"\u003E" + (pug.escape(null == (pug_interp = item.header) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"showtimes__times-container\"\u003E";
if (item.times) {
// iterate item.times
;(function(){
  var $$obj = item.times;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var time = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__time-wrapper\"\u003E\u003Ca" + (" class=\"showtimes__time\""+" target=\"_blank\""+pug.attr("data-date-time", time.dateTimeDisplay, true, true)+pug.attr("href", time.disabled ? 'javascript:void(0);' : time.link, true, true)+pug.attr("disabled", time.disabled, true, true)) + "\u003E" + (null == (pug_interp = time.timeDisplay) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var time = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__time-wrapper\"\u003E\u003Ca" + (" class=\"showtimes__time\""+" target=\"_blank\""+pug.attr("data-date-time", time.dateTimeDisplay, true, true)+pug.attr("href", time.disabled ? 'javascript:void(0);' : time.link, true, true)+pug.attr("disabled", time.disabled, true, true)) + "\u003E" + (null == (pug_interp = time.timeDisplay) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var item = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__info\"\u003E\u003Cdiv class=\"showtimes__title\"\u003E" + (pug.escape(null == (pug_interp = item.header) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"showtimes__times-container\"\u003E";
if (item.times) {
// iterate item.times
;(function(){
  var $$obj = item.times;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var time = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__time-wrapper\"\u003E\u003Ca" + (" class=\"showtimes__time\""+" target=\"_blank\""+pug.attr("data-date-time", time.dateTimeDisplay, true, true)+pug.attr("href", time.disabled ? 'javascript:void(0);' : time.link, true, true)+pug.attr("disabled", time.disabled, true, true)) + "\u003E" + (null == (pug_interp = time.timeDisplay) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var time = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"showtimes__time-wrapper\"\u003E\u003Ca" + (" class=\"showtimes__time\""+" target=\"_blank\""+pug.attr("data-date-time", time.dateTimeDisplay, true, true)+pug.attr("href", time.disabled ? 'javascript:void(0);' : time.link, true, true)+pug.attr("disabled", time.disabled, true, true)) + "\u003E" + (null == (pug_interp = time.timeDisplay) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

};
pug_mixins["showtimes"](data.showTimesGrouped);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};




// iterate data   
;(function(){
  var $$obj = data   ;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__section",index==0 ? 'active': ''], [false,true]), false, true)+pug.attr("data-js-improv-section", month.id, true, true)) + "\u003E";
// iterate month.shows
;(function(){
  var $$obj = month.shows;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var show = $$obj[pug_index5];
pug_mixins["improvMovieCard"]("improv", show);
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var show = $$obj[pug_index5];
pug_mixins["improvMovieCard"]("improv", show);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__section",index==0 ? 'active': ''], [false,true]), false, true)+pug.attr("data-js-improv-section", month.id, true, true)) + "\u003E";
// iterate month.shows
;(function(){
  var $$obj = month.shows;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var show = $$obj[pug_index6];
pug_mixins["improvMovieCard"]("improv", show);
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var show = $$obj[pug_index6];
pug_mixins["improvMovieCard"]("improv", show);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"ww-improv__button-wrapper\" data-js-improv-nav\u003E\u003Cbutton class=\"ww-improv__button ww-improv__button--prev\" data-js-nav-month=\"prev\"\u003E\u003C\u002Fbutton\u003E";
// iterate data
;(function(){
  var $$obj = data;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__month",index==0 ? 'active':''], [false,true]), false, true)+pug.attr("data-js-month-display", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = month.timeDisplay) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var month = $$obj[index];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["ww-improv__month",index==0 ? 'active':''], [false,true]), false, true)+pug.attr("data-js-month-display", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = month.timeDisplay) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cbutton class=\"ww-improv__button ww-improv__button--next\" data-js-nav-month=\"next\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = require("../../components/improv-movie/back-to-top.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined));;return pug_html;};
module.exports = template;